import {
  REPORT_PDF_STATUS_CHECK_START,
  REPORT_PDF_STATUS_CHECK_STOP,
} from '../actions/reportPollingActions';

const initialState = {
  isPolling: false,
  lastChecked: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REPORT_PDF_STATUS_CHECK_START:
      return {
        ...state,
        isPolling: true,
      };

    case REPORT_PDF_STATUS_CHECK_STOP:
      return {
        ...state,
        isPolling: false,
      };

    default:
      return state;
  }
};
